import React from "react";

import { ContatoForm } from "../design-system/components/contatos/ContatoForm.jsx";

import api from "../services/api";


export default function Contatos(){



  async function handleContato(data){


    try {


      const resposta = await api.post(

        "/auth/contato.php",

        data

      );


      console.log(
        "Contato salvo:",
        resposta.data
      );


      alert(
        "Contato cadastrado com sucesso!"
      );



    } catch(error){


      console.error(
        "Erro ao salvar contato:",
        error
      );


      alert(
        "Erro ao cadastrar contato."
      );


    }


  }





  return (

    <div
      className="
        min-h-screen
        bg-background
        flex
        items-center
        justify-center
        px-6
      "
    >


      <ContatoForm

        onSubmit={handleContato}

      />


    </div>


  );


}